import { usePrevious } from '@eti/utils';
import { useEffect, useState } from 'react';
export const useSmallMealPrice = (updateTotalPrice, mealPriceRaw) => {
  const previousPrice = usePrevious(mealPriceRaw);
  useEffect(() => {
    if (mealPriceRaw !== null && mealPriceRaw !== previousPrice) {
      updateTotalPrice(mealPriceRaw);
    }
  }, [previousPrice, mealPriceRaw, updateTotalPrice]);
};
export const useMealCardSelection = (hasAnySelected, cardSelection, selectProduct, selectAllTravelers, travelers) => {
  const [isOpen, setIsOpen] = useState(false);
  const prevHasAnySelected = usePrevious(hasAnySelected);
  const previousCardSelection = usePrevious(cardSelection);
  useEffect(() => {
    if (!hasAnySelected && previousCardSelection && prevHasAnySelected) {
      selectProduct('false');
    }
    if (hasAnySelected && !prevHasAnySelected) {
      selectProduct('true');
    }
  }, [hasAnySelected, selectProduct, prevHasAnySelected, previousCardSelection]);
  useEffect(() => {
    if (cardSelection && previousCardSelection !== cardSelection && !prevHasAnySelected) {
      setIsOpen(true);
      selectAllTravelers(travelers, true);
    }
    if (!cardSelection && cardSelection !== previousCardSelection) {
      selectAllTravelers(travelers, false);
    }
  }, [selectAllTravelers, cardSelection, prevHasAnySelected, previousCardSelection, travelers]);
  return [isOpen];
};
//# sourceMappingURL=hooks.js.map